import { useEffect, useRef, useState } from 'react'
import useStyles from '../styles/styles'

const Reveal = ({ children, delay = 0 }) => {
  const classes = useStyles()
  const element = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true)
        observer.disconnect()
      }
    }, { threshold: 0.12 })
    if (element.current) observer.observe(element.current)
    return () => observer.disconnect()
  }, [])

  return <div ref={element} className={`${classes.reveal} ${visible ? classes.revealed : ''}`} style={{ transitionDelay: `${delay}ms` }}>{children}</div>
}

export default Reveal
